module.exports = __webpack_public_path__ + "img/ico4.c2c484f9.svg";